import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class Keyvisual {
    timeline = null;

    constructor() {
        this.init();
    }

    init() {
        if (this.dom()) {
            gsap.registerPlugin(ScrollTrigger);

            this.destroy();
            this.setup();
        }
    }

    dom() {
        this.$body = $('body');
        this.$keyvisual = $('#keyvisual-wrap');

        if (this.$keyvisual.length < 1) {
            this.$keyvisual = $('#keyvisual');
        }

        this.$keyvisualLogo = this.$keyvisual.find('#keyvisual-logo');
        this.$keyvisualContent = this.$keyvisual.find('#keyvisual-content');
        
        return (
            this.$keyvisual.length > 0 &&
            this.$keyvisualLogo.length > 0 &&
            this.$keyvisualContent.length > 0
        );
    }

    setup() {
        if (this.timeline) return;

        const mm = gsap.matchMedia();

        mm.add(Foundation.MediaQuery.get('large'), () => {
            this.timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$keyvisual.get(0),
                    start: 'top top',
                    end: '+=3500',
                    scrub: true,
                    pin: true,
                    immediateRender: false
                }
            });

            this.timeline.to(this.$keyvisualLogo.get(0), {
                width: "0%",
                duration: 1,
            }, 0);

            this.timeline.set(this.$keyvisualContent.get(0), {
                width: "30%",
                height: "30%",
                opacity: 1,
            }, 0.05);

            this.timeline.to(this.$keyvisualContent.get(0), {
                width: "60%",
                height: "60%",
                ease: "power2.inOut",
                duration: 0.5,
            }, 0.05);

            this.timeline.to(this.$keyvisualContent.get(0), {
                width: "100%",
                height: "100%",
                ease: "power2.inOut",
                duration: 0.20,
            }, 0.55);

            this.timeline.call(this.toggleContentShownClass.bind(this), null, 0.75);
        });
    }

    destroy() {
        if (!this.timeline) return;

        this.timeline.scrollTrigger.kill();
        this.timeline.progress(0).kill();
        this.timeline = null;
    }

    toggleContentShownClass() {
        this.$keyvisual.toggleClass('keyvisual-content-shown');
    }
}

export default Keyvisual;
